import { CLINIC_TIME_ZONE, clinicDateStringFromInstant, clinicTodayDateString } from "./clinicTime";

export function shouldConfirmFutureCheckIn(appointment, now = new Date()) {
  const scheduledDay = clinicDateStringFromInstant(appointment?.scheduled_start);
  const today = clinicTodayDateString(now);
  return Boolean(scheduledDay && today && scheduledDay > today);
}

export function checkInConfirmationMessage(appointment) {
  const patient = appointment?.patient_name || "This patient";
  const date = formatClinicDate(appointment?.scheduled_start);
  return `${patient} is scheduled for ${date}. Only check in patients who are physically in the clinic today. Check in anyway?`;
}

function formatClinicDate(value) {
  const d = value ? new Date(value) : null;
  if (!d || Number.isNaN(d.getTime())) return "a future date";
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: CLINIC_TIME_ZONE,
  });
}
